import React, { useState,useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { dynamicUrl } from '../Function';
import { Container,Card,Placeholder } from 'react-bootstrap';
import Slider from "react-slick";
import '../focusUtils';
const HpDepartments = () => 
{
    const { t } = useTranslation();
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[Pages,setPages]=useState([]);
    useEffect(()=>
    {
        const allDepartments = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"menu/subMenu/3");
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.departments.sd_id + "/sdImage")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.departments.sd_id + "/sdImageHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].sdImage = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].sdImageHi = (el.upb.length > 0) ? global.config.uploadPath + el.upb[0].up_fname + el.upb[0].up_ext : '';
                        });
                        setPages(result);
                        setLoading(false);
                    }).catch(error => {
                        console.error('Departments Image :', error);
                        setLoading(false);
                    });
                }
                else
                {
                    setPages([]);
                    setLoading(false);
                }
                if( global.config.IsPrint === true ) { console.info('Department Pages : Result',result); }
            } catch (error) 
            {
                console.error('Department Pages : Error', error.message);
                setLoading(false);
            }
        };
        allDepartments();
        window.disableFocusInHiddenSlides();
        window.enableFocusInVisibleSlides();   
    },[])
    const settings = {
        autoplay: true,
        centerMode: false,
        infinite: true,
        centerPadding: "0px",
        dots: true,
        slidesToShow: 4,
        speed: 500,
        accessibility: true,
        beforeChange: (current, next) => { window.disableFocusInHiddenSlides(); },
        afterChange: current => { window.enableFocusInVisibleSlides(); },
        responsive: [{ breakpoint: 1024,settings: { slidesToShow: 1 }} ]
    };
    return (
        <section className="hp-department">
            <Container className="py-md-5 py-4 text-center">
                <h2>{t('Departments')}</h2>
                <span className="mb-4 sub-heading"></span>
                {isLoading ? (
                <div className="slider-container px-4 py-3" data-aos="fade-up" data-aos-duration="1500">
                    <Slider {...settings}>
                        {[...Array(5)].map((_,index)=>(
                        <div className='p-3' key={index}>
                            <Card className='text-center card-custom'>
                                <Placeholder xs={12} className="card-img-top" style={{minHeight:"180px"}} />
                                <Card.Body>
                                    <Placeholder xs={10} />
                                </Card.Body>
                                <Card.Footer className='text-bg-info'>
                                    <Placeholder xs={10} />
                                </Card.Footer>
                            </Card>
                        </div>
                        ))}
                    </Slider>
                </div>
                ) : (
                <div className="slider-container px-4 py-3" data-aos="fade-up" data-aos-duration="1500">
                    <Slider {...settings}>
                        {Pages.map((sp, index)=>(
                            <div className='p-3 h-100' key={index}>
                                <Card className='text-center card-custom'>
                                    {appLanguage === 'hi' ? 
                                        (
                                            sp.sdImageHi 
                                            ? <Card.Img variant="top" className="img-fluid" src={sp.sdImageHi} width={260} height={160} alt={`${sp.sp_name_hi} विभाग`} loading="lazy" /> 
                                            : sp.sdImage 
                                                ? <Card.Img variant="top" className="img-fluid" src={sp.sdImage} width={260} height={160} alt={`${sp.sp_name_hi} विभाग`} loading="lazy" /> 
                                                : <Placeholder xs={12} className="card-img-top" width={260} height={160} />
                                        ) : (
                                            sp.sdImage 
                                            ? <Card.Img variant="top" className="img-fluid" src={sp.sdImage} width={260} height={160} alt={`${sp.sp_name} department`} loading="lazy" /> 
                                            : <Placeholder xs={12} className="card-img-top" width={260} height={160} />
                                        )
                                    }                                            
                                    <Card.Body>
                                        <Card.Title className='fs-6 mb-0'>
                                            { appLanguage === 'hi' ? sp.sp_name_hi || sp.sp_name : sp.sp_name }
                                        </Card.Title>
                                    </Card.Body>
                                    <Card.Footer className='text-bg-info'>
                                        <NavLink to={dynamicUrl(sp)} className='link-light' aria-label={ appLanguage === 'hi' ? sp.sp_name_hi || sp.sp_name : sp.sp_name }>
                                            {t('ReadMore')} <i className="bi bi-arrow-right-short"></i>
                                        </NavLink>
                                    </Card.Footer>
                                </Card>
                            </div>
                        ))}
                    </Slider>
                </div>
                )}
            </Container>
        </section>
    );    
}
export default HpDepartments;